@if (items$().length > 0) {
  <sol-layout px="16" pt="16" gap="16">
    @for (item of items$(); track item.id) {
      <sol-alert [type]="item.type" [text]="item.heading" [info]="item.description" />
    }
  </sol-layout>
}
